import { InfoCircleIcon, UserIcon } from '@shares/DMPIcon'
import { Icon, Input } from 'antd'
import Form, { WrappedFormUtils } from 'antd/lib/form/Form'
import React from 'react'

type TFormInputEmailAddress = {
    form: WrappedFormUtils
}

const FormInputEmailAddress = (props: TFormInputEmailAddress) => {
    return (
        <Form.Item label="Email address" style={{ marginBottom: 0 }}>
            {props.form?.getFieldDecorator('userName', {
                rules: [
                    {
                        required: true,
                        message: "Please enter your email address"
                    },
                    // || props.locale.message["app.login.username.required"],
                    {
                        type: 'email',
                        message: <><Icon component={InfoCircleIcon} style={{
                            paddingRight: 4
                        }} />Incorrect email address!</>,
                    },
                ],
            })(
                <Input
                    prefix={<Icon style={{ paddingRight: 10 }} component={UserIcon} />}
                    placeholder="Enter your email address" autoComplete="off"
                />
            )}
        </Form.Item>
    )
}

export default FormInputEmailAddress